import React from "react";
import { Trans } from "react-i18next";
import styles from "./cards.module.scss";
import { useTranslation } from "lib/i18n/use-translation";
import { ReactComponent as LotusIcon } from "Assets/icon/icon-lotus.svg";
import postSsessionCheckIcon from "Assets/icon/icon_check_grey.svg";
import { sessionOrdinalCount } from "utility/Function";
import clsx from "clsx";

interface SessionFeedbackCardProps {
  title: string;
  imageUrl: string;
  practitionerName: string;
  sessionCount: string;
}

const SessionFeedbackCard: React.FC<SessionFeedbackCardProps> = ({
  title,
  imageUrl,
  practitionerName,
  sessionCount,
}) => {
  const { t } = useTranslation(["feedback"]);
  const cardBackground = {
    backgroundImage: `
    linear-gradient(to top, rgba(0, 0, 0, 0.5) 10%, rgba(0, 0, 0, 0) 40%),
    url(${imageUrl})`,
  };
  const sessionCountNumber = Number(sessionCount);
  return (
    <div className={styles["session-feedback-card-container"]}>
      <div
        data-testid="session-feedback-card-body"
        style={cardBackground}
        className={clsx(styles["session-feedback-card-body"], {
          [styles["session-feedback-body-no-session"]]:
            sessionCountNumber === 0,
        })}
      >
        <div className={styles["session-feedback-card-icon"]}>
          <img src={postSsessionCheckIcon} alt="Post Session Icon" />
        </div>
        <div className={styles["session-feedback-card-content"]}>
          <p className={styles["session-feedback-card-title"]}>{title}</p>
          <p className={styles["session-feedback-card-author"]}>
            {t("feedback:withPractitioner", { name: practitionerName })}
          </p>
        </div>
      </div>
      {sessionCountNumber > 0 && (
        <div className={styles["session-feedback-card-footer"]}>
          <div className={styles["session-feedback-card-footer-icon"]}>
            <LotusIcon />
          </div>
          <p>
            <Trans
              i18nKey="feedback:completedSession"
              values={{
                session: `${sessionOrdinalCount(
                  parseInt(sessionCount, 10)
                )} session`,
              }}
              components={{ bold: <b /> }}
            />
          </p>
        </div>
      )}
    </div>
  );
};
export default SessionFeedbackCard;
